import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MenuItemsGroupSection from "./MenuItemsGroupSection";


const MenuItemsList = ({ menuGroups, addToSectionsRefs }) => {
  // useEffect(()=>{
  //   // console.log("MenuGroups array");
  //   // console.log(menuGroups);
  // },[menuGroups]);
  return (
    <>
      {
        menuGroups.map(group => (
          <MenuItemsGroupSection groupItem={ group } addToSectionsRefs={ addToSectionsRefs } />
        ))
      }
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    menuGroups
  } = state;

  return {
    menuGroups
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemsList);

